import { render, staticRenderFns } from "./TwoCheckDialog.vue?vue&type=template&id=c4ef4470&scoped=true&"
import script from "./TwoCheckDialog.vue?vue&type=script&lang=js&"
export * from "./TwoCheckDialog.vue?vue&type=script&lang=js&"
import style0 from "./TwoCheckDialog.vue?vue&type=style&index=0&id=c4ef4470&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ef4470",
  null
  
)

export default component.exports